import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import LeaveModal from '../../../../components/home/LeaveModal/LeaveModal'
import {
  StyledBanner,
  BannerContent,
  BannerDescription,
  RewardsCatalogTitle,
  Heading,
  FormContainer,
  StyledInputWithSuggestion,
  CategorySelectContainer,
  StyledDropdown,
  Content,
  StyledCatalogList,
  ErrorCard,
  ZingIconComponent,
  StyledLink,
  StyledShopDineCard,
  CardContent,
  LogoContainer,
  Logo,
  LogoFiller,
  Title,
} from './MainView.style'

import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)
    const {
      history,
      accessToken,
      doGetAllMalls,
      doGetAllBrands,
      doGetShopCategories,
    } = props
    const { location } = history

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      searchQuery: initialSearch.q || '',
      searched: [],
      malls: [],
      mallList: [],
      showLeaveModal: false,
      selectedBrand: {},
      suggestedCurrentIndex: -1,
      showSuggestion: false,
      selectedCategoryId: 'default',
      selectedCategory: { value: 'default', name: 'All' },
      storeList: [],
      categories: [{ value: 'default', name: 'All' }],
      stores: [],
      promoCode: '',
    }

    doGetAllMalls(this.setState.bind(this))
    doGetAllBrands({ accessToken }, this.setState.bind(this))
    doGetShopCategories(this.setState.bind(this))
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
    // this.getPromoCode()
  }

  componentDidUpdate(prevProps) {
    const {
      // match,
      location,
    } = this.props
    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    renderServer()
  }

  onSearchBrand = e => {
    const { stores } = this.state
    const { value: brand } = e.target || {}
    const searchQuery = brand.toLowerCase()

    const searched = stores.filter(store => {
      const storeName = store.name.toLowerCase()

      return storeName.includes(searchQuery)
    })

    this.setState({
      showSuggestion: true,
      suggestedCurrentIndex: -1,
      searched,
      searchQuery: brand,
    })
  }

  handleShowLeaveModal = brand => {
    this.setState({
      showLeaveModal: true,
      selectedBrand: brand,
    })
  }

  handleCloseLeaveModal = onProceed => {
    if (onProceed) {
      const { selectedBrand } = this.state
      setGAEvent('view_shop_online_link', 'value', selectedBrand.onlineShopUrl)
    }

    this.setState({
      showLeaveModal: false,
    })
    setTimeout(
      () =>
        this.setState({
          selectedBrand: {},
        }),
      10,
    )
  }

  handleSelectSuggestion = (store, index) => {
    this.setState({
      showSuggestion: false,
      suggestedCurrentIndex: index,
      selectedBrand: store,
      searchQuery: store.name,
      searched: [store],
    })
  }

  onEnter = (selectedSuggestion, queryState, searched) => {
    this.setState({
      selectedBrand: selectedSuggestion,
      searchQuery: queryState,
      searched: searched,
    })
  }

  handleRedirectToRegister = () => {
    const { push } = this.props
    push('/register')
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      primaryInfo,
      doChangeCategories,
      ...theProps
    } = this.props

    const {
      searchQuery: searchQueryState,
      categories,
      stores,
      searched,
      showLeaveModal,
      selectedBrand,
      showSuggestion,
      selectedCategory,
      // suggestedCurrentIndex,
      // promoCode,
    } = this.state

    const selectedMall = this.state.malls.find(
      mall =>
        mall.slugName === selectedMallSlug && mall.explore && mall.slugName,
    )

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>ZingShops</RewardsCatalogTitle>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout
        banner={Banner}
        isEConcierge={true}
        match={match}
        selectedMall={selectedMall}
        accessToken={accessToken}
        {...theProps}
      >
        <Heading>
          <FormContainer>
            <StyledInputWithSuggestion
              variant="search"
              whiteOut
              iconColor={'#fff'}
              placeholder="Search Brand"
              onChange={this.onSearchBrand}
              value={searchQueryState}
              onEnter={this.onEnter}
              showSuggestion={showSuggestion}
              handleSelectSuggestion={this.handleSelectSuggestion}
              dataSource={searched}
            />
            <CategorySelectContainer>
              <StyledDropdown
                name="category"
                data-testid="category"
                initialValue={'default'}
                label="Category: "
                options={categories.sort((a, b) =>
                  a.value !== 'default' ? a.id - b.id : -1,
                )}
                onChange={doChangeCategories({
                  accessToken,
                  selectedCategory,
                  setQueryResults: this.setState.bind(this),
                })}
                required
              />
            </CategorySelectContainer>
          </FormContainer>
        </Heading>
        <Content>
          {stores && stores.length > 0 && (
            <StyledCatalogList
              dataSource={searchQueryState.length ? searched : stores}
              loadingComponent={() => (
                <ErrorCard>
                  <ZingIconComponent />
                </ErrorCard>
              )}
              renderItem={(merchant, index) => (
                <StyledLink
                  onClick={() => {
                    this.handleShowLeaveModal(merchant)
                  }}
                >
                  <StyledShopDineCard cardImageUrl={merchant.backgroundUrl}>
                    <CardContent>
                      <LogoContainer cardImageUrl={merchant.backgroundUrl}>
                        {merchant.logoUrl ? (
                          <Logo src={merchant.logoUrl} />
                        ) : (
                          <LogoFiller>&nbsp;</LogoFiller>
                        )}
                      </LogoContainer>
                      <Title>{merchant.name}</Title>
                    </CardContent>
                  </StyledShopDineCard>
                </StyledLink>
              )}
            />
          )}
        </Content>
        {/* <Helmet>
          <meta http-equiv="cache-control" content="no-cache" />
          <meta http-equiv="expires" content="0" />
          <meta http-equiv="pragma" content="no-cache" />
        </Helmet> */}
        <LeaveModal
          show={showLeaveModal}
          onClose={() => {
            this.handleCloseLeaveModal()
          }}
          onAltClose={!accessToken && this.handleRedirectToRegister}
          altCloseTitle={!accessToken && 'Join Now'}
          to={
            selectedBrand.onlineShopUrl
              ? /https:\/\/[a-zA-Z0-9]+/.test(selectedBrand.onlineShopUrl)
                ? selectedBrand.onlineShopUrl
                : `https://${selectedBrand.onlineShopUrl}`
              : ''
          }
          onProceed={() => {
            this.handleCloseLeaveModal(true)
          }}
          isLoggedIn={accessToken}
          promoCode={selectedBrand && selectedBrand.promoCode}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
